import React from 'react';
import CourtEditor from './CourtEditor';
import './Settings.css';

const Settings = () => {

    return (
        <div className="settings-container">
            <div className="settings-header">
                <h1>⚙️ Ustawienia</h1>
            </div>
            <div className="settings-content">
                <div className="settings-section">
                    <h2>🏟️ Zarządzanie kortami</h2>
                    <CourtEditor />
                </div>
            </div>
        </div>
    );
};

export default Settings;
